<template>
  <div class="list-table">
    <el-row class="list-table-row">
      <el-col
        :span="6"
        class="list-table-row-header"
      >
        <span v-text="courseName"></span>
      </el-col>
      <el-col
        :span="18"
        class="list-table-row-content"
      >
        &nbsp;
      </el-col>
    </el-row>
    <el-row class="list-table-row">
      <el-col
        :span="6"
        class="list-table-row-header"
      >
        <span>总人数</span>
      </el-col>
      <el-col
        :span="18"
        class="list-table-row-content"
      >
        <span v-text="getTotalCountText()"></span>
      </el-col>
    </el-row>
    <el-row class="list-table-row">
      <el-col
        :span="6"
        class="list-table-row-header"
      >
        <span>出席率</span>
      </el-col>
      <el-col
        :span="18"
        class="list-table-row-content"
      >
        <span v-text="getPresenceText()"></span>
      </el-col>
    </el-row>
    <el-row class="list-table-row">
      <el-col
        :span="6"
        class="list-table-row-header"
      >
        <span>缺席率</span>
      </el-col>
      <el-col
        :span="18"
        class="list-table-row-content"
      >
        <span v-text="getAbsenceText()"></span>
      </el-col>
    </el-row>
    <el-row class="list-table-row cs-row-student">
      <el-col
        :span="6"
        class="list-table-row-header cs-red-label"
      >
        <span>不能上课的学生</span>
      </el-col>
      <el-col
        :span="18"
        class="list-table-row-content"
      >
        <span v-if="unavailableStudentList.length == 0">&nbsp;</span>
        <span
          :class="{'cs-list-item':true, 'isClicked':checkIsClicked(item.StudentId)}"
          v-for="(item,index) in unavailableStudentList"
          :key="index"
          @click="showStudent(item.StudentId, index)"
          v-text="formatPhone(item.StudentName)"
        ></span>

      </el-col>
    </el-row>
    <el-row class="list-table-row cs-row-student">
      <el-col
        :span="6"
        class="list-table-row-header"
      >
        <span>能上课的学生</span>
      </el-col>
      <el-col
        :span="18"
        class="list-table-row-content"
        v-loading="isLoading"
      >
        <span v-if="availableStudentList.length == 0">&nbsp;</span>
        <span
          :class="{'cs-list-item':true, 'isClicked':checkIsClicked(item.StudentId)}"
          v-for="(item,index) in availableStudentList"
          :key="index"
          @click="showStudent(item.StudentId, index)"
          v-text="item.StudentName"
        ></span>

      </el-col>
    </el-row>
    <el-row
      class="list-table-row cs-row-student"
      v-if="!!unavailableTeacherList && unavailableTeacherList.length > 0"
    >
      <el-col
        :span="6"
        class="list-table-row-header"
      >
        <span>不能上课的老师</span>
      </el-col>
      <el-col
        :span="18"
        class="list-table-row-content"
      >
        <span v-if="unavailableTeacherList.length == 0">&nbsp;</span>
        <span
          :class="{'cs-list-item':true, 'isClicked':checkIsClickedTeacher(index)}"
          v-for="(item,index) in unavailableTeacherList"
          :key="index"
          v-text="item.TeacherName"
          @click="showTeacher(item, index)"
        ></span>

      </el-col>
    </el-row>
    <el-dialog
      append-to-body
      title="在校课程时间表"
      :center="true"
      :close-on-click-modal="false"
      width="70%"
      :visible.sync="displayStudentCourse"
      top="5vh"
    >
      <studentCourseReview
        :data="currentStudentData"
        @close="closeStudentCourse"
        v-on:dialogFormVisibleEvent="onDialogFormVisibleEvent"
      ></studentCourseReview>
    </el-dialog>
     <el-dialog  append-to-body title="老师课程时间表" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayTeacherCourse" top="5vh">
      <teacherCourseReview :data="teacherCourseData" @close="closeTeacherCourse" v-on:dialogFormVisibleEvent="onTeacherDialogVisibleEvent"></teacherCourseReview>
    </el-dialog> 
  </div>
</template>

<style lang="scss" scoped>
.list-table {
  width: 100%;
  padding: 0 40px;
  margin-bottom: 40px;

  .list-table-row {
    border-bottom: 1px solid #dbdbdb;
    border-left: 1px solid #dbdbdb;
    border-right: 1px solid #dbdbdb;
    line-height: 50px;

    &:first-child {
      border-top: 1px solid #dbdbdb;
      line-height: 33px;
      background-color: #f0f0f0;
    }

    .list-table-row-header {
      background-color: #f0f0f0;
      font-weight: bold;
      text-align: center;
    }
    .list-table-row-content {
      text-align: left;
      padding: 0 30px;

      .cs-list-item {
        width: 20%;
        display: inline-block;
        cursor: pointer;
        color: #3388c2;

        &:hover {
          opacity: 0.9;
        }
      }
    }

    &.cs-row-student {
      position: relative;

      .list-table-row-header {
        position: absolute;
        height: 100%;
      }

      .list-table-row-content {
        float: right;
      }
    }
  }
}
</style>

<script>
import {
  getScheduleStudentList
} from "../../service/speedupCourse.service";

import studentCourseReview from "../studentCourseReview";
import teacherCourseReview from "../teacherCourseReview";
import global_ from "@/core/global";
import {formatPhone} from "../../config/mUtils"

export default {
  data() {
    return {
      displayStudentCourse: false,
      currentStudentData: {},
      courseName: "",
      totalCount: 0,
      unavailableCount: 0,
      unavailableStudentList: [],
      unavailableTeacherList: [],
      scheduleStudentList: [],
      availableStudentList: [],
      planId: 0,
      termId: 0,
      plan:{},
      clickedStudentList: [],
      displayTeacherCourse: false,
      clickedTeacherList:[],
      teacherCourseData:{},
      isLoading : false
    };
  },
  components: {
    studentCourseReview,
    teacherCourseReview
  },
  props: {
    data: {}
  },
  created() {
    this.loadData();
  },
  methods: {
    formatPhone(phone){
      if (!this.USERMANAGER.isAdmin && !this.USERMANAGER.isFinancialManager && !this.USERMANAGER.isRegionCEO){
        return formatPhone(phone);
      }
      return phone;
    },
    closeTeacherCourse() {
      this.displayTeacherCourse = false;
    },
    onTeacherDialogVisibleEvent(visible) {
      this.displayTeacherCourse = visible;
    },
    closeStudentCourse() {
      this.displayStudentCourse = false;
    },
    onDialogFormVisibleEvent(visible) {
      this.displayStudentCourse = visible;
    },
    getTotalCountText() {
      return this.totalCount.toString() + "人";
    },
    getPresenceText() {
      let count = this.totalCount - this.unavailableCount;
      let percentage = 0;
      if (!!this.totalCount) {
        percentage = Math.round((100 * count) / this.totalCount);
      }
      let text = percentage.toString() + "% (" + count.toString() + "人)";
      return text;
    },
    getAbsenceText() {
      let percentage = 0;
      if (!!this.totalCount) {
        percentage = Math.round(
          (100 * this.unavailableCount) / this.totalCount
        );
      }
      let text =
        percentage.toString() +
        "% (" +
        this.unavailableCount.toString() +
        "人)";
      return text;
    },
    showStudent(id, index) {
      this.currentStudentData = {
        studentId: id,
        planId: this.planId,
        termId: this.termId
      };
      this.displayStudentCourse = true;

      if (this.clickedStudentList.indexOf(id) < 0){
        this.clickedStudentList.push(id);
      }
    },
    checkIsClicked(id) {
      return this.clickedStudentList.indexOf(id) >= 0;
    },
    showTeacher(item, index) {
      this.teacherCourseData = {
        teacherId: item.TeacherId,
        teacherName: item.TeacherName,
        plan: this.plan
      };
 
      this.displayTeacherCourse = true;

      let list = [];
      this.clickedTeacherList.forEach(element => {
        list.push(element);
      });
      list[index] = true;
      this.clickedTeacherList = list;
    },
    checkIsClickedTeacher(index){
       return this.clickedTeacherList[index];
    },
    loadData() {
      if (!!this.data){
        this.courseName = "课程：" + this.data.courseName;
        if (this.data.courseClass) {
          this.courseName += "-分班" + this.data.courseClass;
        }
        this.totalCount = this.data.totalCount;
        this.unavailableCount = this.data.unavailableCount;
        this.unavailableStudentList = this.data.unavailableStudentList;
        this.unavailableTeacherList = this.data.unavailableTeacherList;
        this.planId = this.data.planId;
        this.termId = this.data.termId;
        this.plan = this.data.plan;
        
        this.clickedStudentList = [];

        this.clickedTeacherList = [];
        this.unavailableTeacherList.forEach(element => {
          this.clickedTeacherList.push(false);
        });

        this.isLoading = true;
        getScheduleStudentList(
          this.data.termId,
          this.data.planId,
          this.data.courseId,
          this.data.teacherId,
          this.data.courseClass
        ).then(result => {
          if (!!result && result.success) {
            this.scheduleStudentList = result.data;
            this.loadAvailableStudentList();
            this.isLoading = false;
          }
        });
      }
    },
    loadAvailableStudentList(){
      let list = [];
     
      for(let i = 0; i < this.scheduleStudentList.length; i ++){
        let item = this.scheduleStudentList[i];
        let index = this.unavailableStudentList.findIndex(i => i.StudentId == item.StudentId);
        if (index < 0){
          list.push(item);
        }
      }

      this.availableStudentList = list;
    }
  },
  watch: {
    data: function() {
      this.loadData();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/speedupCourse/speedupCourseScheduleDetail.vue